import { render, staticRenderFns } from "./authenticated.home.vue?vue&type=template&id=61550703"
import script from "./authenticated.home.vue?vue&type=script&lang=ts"
export * from "./authenticated.home.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports